var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('b-progress',{staticClass:"progress"},[_c('b-progress-bar',{attrs:{"value":_vm.value}})],1),_vm._v(" "),_c('div',{staticClass:"text"},[_c('span',[_vm._v(_vm._s(_vm.textValue))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }